export interface NavItem {
  to: string;
  labelKey: string;
  descriptionKey?: string;
}

export interface NavGroup {
  labelKey: string;
  to?: string;
  items?: NavItem[];
}

export interface FooterGroup {
  headingKey: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  { labelKey: 'nav.home.label', to: '/' },
  {
    labelKey: 'navGroups.challenges',
    items: [
      { to: '/project', labelKey: 'nav.project.label', descriptionKey: 'nav.project.description' },
      { to: '/race/2026', labelKey: 'nav.race2026.label', descriptionKey: 'nav.race2026.description' },
      { to: '/race', labelKey: 'nav.race.label', descriptionKey: 'nav.race.description' },
      { to: '/kilimanjaro', labelKey: 'nav.kilimanjaro.label', descriptionKey: 'nav.kilimanjaro.description' },
      { to: '/kilimanjaro/route', labelKey: 'nav.kilimanjaroRoute.label', descriptionKey: 'nav.kilimanjaroRoute.description' },
    ],
  },
  {
    labelKey: 'navGroups.gear',
    items: [
      { to: '/equipments', labelKey: 'nav.equipments.label', descriptionKey: 'nav.equipments.description' },
      { to: '/kilimanjaro/equipments', labelKey: 'nav.kilimanjaroEquipments.label', descriptionKey: 'nav.kilimanjaroEquipments.description' },
      { to: '/equipment-guide', labelKey: 'nav.equipmentGuide.label', descriptionKey: 'nav.equipmentGuide.description' },
      { to: '/cost', labelKey: 'nav.cost.label', descriptionKey: 'nav.cost.description' },
    ],
  },
  {
    labelKey: 'navGroups.gallery',
    items: [
      { to: '/photos', labelKey: 'nav.photos.label', descriptionKey: 'nav.photos.description' },
      { to: '/kilimanjaro/photos', labelKey: 'nav.kilimanjaroPhotos.label', descriptionKey: 'nav.kilimanjaroPhotos.description' },
    ],
  },
  {
    labelKey: 'navGroups.about',
    items: [
      { to: '/profile', labelKey: 'nav.profile.label', descriptionKey: 'nav.profile.description' },
      { to: '/support', labelKey: 'nav.support.label', descriptionKey: 'nav.support.description' },
      { to: '/contact', labelKey: 'nav.contact.label', descriptionKey: 'nav.contact.description' },
    ],
  },
];

/**
 * ヘッダーと同じ区分け・同じ並び。片方だけ動かすと同じページの居場所が2つになるので、
 * ずれは navigation.test.ts で落とす（フッターだけに置くページは同ファイルの許可リストへ）。
 */
export const FOOTER_GROUPS: FooterGroup[] = [
  {
    headingKey: 'navGroups.challenges',
    items: [
      { to: '/project', labelKey: 'footer.links.project' },
      { to: '/race/2026', labelKey: 'footer.links.race2026' },
      { to: '/race', labelKey: 'footer.links.race' },
      { to: '/kilimanjaro', labelKey: 'footer.links.kilimanjaro' },
      { to: '/kilimanjaro/route', labelKey: 'footer.links.kilimanjaroRoute' },
    ],
  },
  {
    headingKey: 'navGroups.gear',
    items: [
      { to: '/equipments', labelKey: 'footer.links.equipments' },
      { to: '/kilimanjaro/equipments', labelKey: 'footer.links.kilimanjaroEquipments' },
      { to: '/equipment-guide', labelKey: 'footer.links.equipmentGuide' },
      { to: '/cost', labelKey: 'footer.links.cost' },
    ],
  },
  {
    headingKey: 'navGroups.gallery',
    items: [
      { to: '/photos', labelKey: 'footer.links.photos' },
      { to: '/kilimanjaro/photos', labelKey: 'footer.links.kilimanjaroPhotos' },
    ],
  },
  {
    headingKey: 'navGroups.about',
    items: [
      { to: '/profile', labelKey: 'footer.links.profile' },
      { to: '/support', labelKey: 'footer.links.support' },
      { to: '/contact', labelKey: 'footer.links.contact' },
      { to: '/links', labelKey: 'footer.links.links' },
    ],
  },
];
